import { useNavigate } from 'react-router-dom'
import type { Chat } from '@ztechapps/common.contract'
import type { DataTableProps } from '@ztechapps/webui.data-tools'
import { DataTable } from '@ztechapps/webui.data-tools'
import { useConversationHost } from '../ConversationHost'
import { useConversationInboxContext } from './Context'
import { ListHeader } from './ListHeader'
import { InboxListRow } from './InboxListRow'

export const InboxList = ({
  fields,
  listResult,
  row,
  head,
  stats,
  tableOptions,
  onRowDoubleClick,
  ...props
}: Partial<DataTableProps<Chat>>) => {
  const { chatList, chatListWithSelection, fieldConfig } = useConversationInboxContext()
  const { conversationFlyoutUrl } = useConversationHost()
  const navigate = useNavigate()

  //No scroll wrapper here: DataTable renders directly into the page's flex-column pane (like
  //OrderList and CompanyList), so its own Scrollable is the scroll region and the stats footer
  //stays pinned below the grid. Scroll-to-bottom auto-load runs on that same Scrollable
  //(DataTable Layout's useLoadMoreOnScroll).
  return (
    <DataTable
      {...props}
      fields={fields ?? fieldConfig}
      listResult={listResult ?? { ...chatList, list: chatListWithSelection.list }}
      row={row ?? InboxListRow}
      head={head ?? ListHeader}
      stats={stats ?? 'conversations'}
      tableOptions={{ ...tableOptions, responsive: true }}
      onRowDoubleClick={onRowDoubleClick ?? ((item) => navigate(conversationFlyoutUrl(item.externalId ?? item._id)))}
    />
  )
}
